import React from "react";

const WORDS = ["COURAGE", "DISCIPLINE", "BRAVE", "RESPECT", "CHAMPION", "WARRIOR SPIRIT", "RISE", "PAHLAWAN", "FIGHTER"];

export const Marquee = () => {
  const strip = [...WORDS, ...WORDS];
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-void/60 py-5" data-testid="marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {strip.map((w, i) => (
          <div key={i} className="flex items-center">
            <span
              className={`px-8 font-display text-4xl tracking-tight sm:text-6xl ${
                i % 2 === 0 ? "text-white" : "neon-outline"
              }`}
            >
              {w}
            </span>
            <span className="text-3xl text-neon-pink sm:text-5xl">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};
